<mat-card>
  <mat-card-content>
    <mat-tab-group animationDuration="0ms">
      <mat-tab label="Updates">
        <div *ngIf="!ifcFileGroups?.length && !loadingUpdates">
          No home catalog data available
        </div>
        <div *ngIf="ifcFileGroups?.length && !loadingUpdates">
          <table>
            <tr>
              <th class="column-date"></th>
              <th class="column-home"> Home </th>
              <th class="column-files"> Files </th>
            </tr>
            <ng-container *ngFor="let ifcFileGroup of ifcFileGroups;">
              <tr class="row-date">
                <td class="column-date">{{ ifcFileGroup.minDate | date:'medium' }} - <br /> {{ ifcFileGroup.maxDate | date:'medium' }}</td>
                <th class="column-environment" colspan="2">
                  <span *ngFor="let environment of ifcFileGroup.environmentSettings; index as i;">
                    <span class="text-success">
                      {{ environment.getProductsString() }}
                    </span>
                    <span class="environment-date">
                      {{ environment.getDistinctEnvironmentsList() }}
                      <span *ngIf="environment.defaultCuttoffDate" class="cut-off-date">
                        &nbsp;[{{ environment.defaultCuttoffDate | date:'medium' }}]</span>
                      <span *ngIf="!environment.defaultCuttoffDate" class="cut-off-date">
                        &nbsp;[n/a]</span>
                    </span>
                    <ng-container *ngIf="i != ifcFileGroup.environmentSettings.length-1"><br /> </ng-container>
                  </span>
                </th>
              </tr>

              <tr class="row-home" *ngFor="let groupDetails of ifcFileGroup.ifcFileGroupDetails">
                <td class="column-date"></td>
                <td class="column-home"><a
                    [routerLink]="['../../homes/', groupDetails.home]">{{groupDetails.home}}</a>
                </td>
                <td class="column-files">
                  <span *ngFor="let file of groupDetails.files; index as i">
                    <a [routerLink]="['../../homes/', groupDetails.home]" matTooltip="{{ file?.dateAdded | date:'medium' }}"
                      [queryParams]="{ifcFile: file.name, v: file.version}">{{
                      file.name
                      }}</a>
                    <ng-container *ngIf="i != groupDetails.files.length-1">, </ng-container>

                  </span>
                </td>
              </tr>
            </ng-container>

          </table>
        </div>

        <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="[50, 250, 1000, 5000]"
          (page)="onPageChange($event)">
        </mat-paginator>
      </mat-tab>
      <mat-tab label="Errors">
        <div *ngIf="!ifcErrors?.length && !loadingErrors">
          No errors to show.
        </div>
        <div *ngIf="ifcErrors?.length  && !loadingErrors">
          <table class="table-errors">
            <tr>
              <th class="column-date"> Date </th>
              <th class="column-severity"> Severity </th>
              <th class="column-error"> Error </th>
              <th class="column-file"> File </th>
            </tr>
            <tr class="row-error" *ngFor="let ifcError of ifcErrors">
              <td class="column-date">{{ ifcError.maxDate | date:'medium' }}</td>
              <td class="column-severity"
                [ngClass]="{'text-danger' : ifcError.severity == 'Error', 'text-warning' : ifcError.severity == 'Warning'}">
                {{ ifcError.severity }}</td>
              <td class="column-error">{{ ifcError.error }}</td>
              <td class="column-file">{{ ifcError.ifcFile }}</td>
            </tr>
          </table>
        </div>
        <mat-paginator [length]="totalErrors" [pageSize]="errorPageSize" [pageSizeOptions]="[5, 10, 25]"
          (page)="onErrorsPageChange($event)">
        </mat-paginator>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
